import {reactive} from 'vue'

export const store = reactive({
    params: [35,0.5], //size, complexity
    size: 35 ,
    complexity: 25,
    backgroundBrightness: 250,
    selectedBlob: null,
    outRes: 10800,
    videoResolution: 1080,
    imageResolution: 10800,
    frameRate:0,
    currentPalette: 0,
    exportOptions: [],
    color1: null,
    color2: null,
    color3: null,
    recording: false,
    totalFramesRecorded: 0,
    runnerInstance: null,
    findingCell: false
 })
